module.exports = __webpack_public_path__ + "static/media/hand-holding-heart.51e335d6.svg";